import { render } from "./VF-accordion.vue?vue&type=template&id=b638d598&scoped=true"
import script from "./VF-accordion.vue?vue&type=script&lang=js"
export * from "./VF-accordion.vue?vue&type=script&lang=js"

import "./VF-accordion.vue?vue&type=style&index=0&id=b638d598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b638d598"]])

export default __exports__